import React from "react";

import Context from "shared/util/Context";

import Carousel, {
	CarouselItem,
} from "apps/payment/components/Carousel";
import { DESCRIPTIONS } from "apps/boosts/util/constants";

import Bolt from "../svgs/bolt.svg";
import Heart from "../svgs/heart.svg";
import Spotlight from "../svgs/spotlight.svg";

const ASSETS = [
	{ name: "bolt-1", icon: <Bolt /> },
	{ name: "bolt-2", icon: <Bolt /> },
	{ name: "heart-1", icon: <Heart /> },
	{ name: "heart-2", icon: <Heart /> },
	{ name: "heart-3", icon: <Heart /> },
	{ name: "heart-4", icon: <Heart /> },
	{ name: "spotlight", icon: <Spotlight /> },
];

const Description = () => {
	const thumbnail = Context.get("thumbnail");

	return (
		<div className="boostpackages-description">
			<img src={thumbnail} alt="thumbnail" className="boostpackages-description-icon boostpackages-description-thumbnail" />
			{ASSETS.map((asset) => {
				return (<div className={`boostpackages-description-icon boostpackages-description-${asset.name}`} key={asset.name}>{asset.icon}</div>);
			})}
			<Carousel>
				{DESCRIPTIONS.map((description, index) => (
					<CarouselItem
						key={description.header}
						index={index}
						totalItemCount={DESCRIPTIONS.length}
					>
						<h2 className="boostpackages-description-header">
							{description.header}
						</h2>
						<p
							className="boostpackages-description-paragraph">
							{description.paragraph}
						</p>
					</CarouselItem>
				))}
			</Carousel>
		</div>
	);
};

export default Description;



// WEBPACK FOOTER //
// ./src/apps/boosts/components/ProductPackageScreen/Description.jsx